import React from "react";
import styled from "styled-components";
import Container from "../../../Components/Container";
import LocationsBG from "../assets/Locations.svg";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";

const LocationsStyles = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 3;

  color: white;
  align-items: flex-end;
  font-size: 48px;

  span {
    margin-bottom: 40px;
    margin-left: 30px;
  }
`;

const Locations = () => {
  return (
    <Container>
      <BGImageDisplay bgimage={LocationsBG} />
      <LocationsStyles>
        <span> LOCATIONS </span>
      </LocationsStyles>
    </Container>
  );
};

export default Locations;
